module.exports = {
        srcSet: __webpack_public_path__ + "3fd640943eeb5bf8-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "3fd640943eeb5bf8-1000.webp",width: 1000,height: 563}],
        src: __webpack_public_path__ + "3fd640943eeb5bf8-1000.webp",
        toString: function(){return __webpack_public_path__ + "3fd640943eeb5bf8-1000.webp"},
        
        width: 1000,
        height: 563
      }